import { LoadingButton } from "@mui/lab";
import { CircularProgress } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const AnalysisCard = ({ className, icon, name, value, iconAb, url, cost }) => {
    return (
        <Link to={"/dashboard/" + url}>
            <CardStyled className={className}>
                <div className="icons">{icon}</div>
                <div className="data">
                    <span className="key" mb={2}>
                        {name}
                    </span>
                    <span className="value">
                        {value === 0 &&
                            0
                            // <CircularProgress style={{ color: "#fff" }} />
                        }
                        {value !== 0 && value}
                    </span>
                    <span className="cost">
                        {" "}
                        {cost ? (cost === 0 ? "" : cost + " $") : ""}{" "}
                    </span>
                </div>
                <div className="iconback">{iconAb}</div>
            </CardStyled>
        </Link>
    );
};

const CardStyled = styled.div`
    position: relative;
    overflow: hidden;
    padding: 1rem 2rem;
    border-radius: 1rem;

    min-height: 170px;
    box-shadow: 0 5px 8px var(--box-shadow);
    transition: all 0.3s;
    background: linear-gradient(
        112.1deg,
        rgba(32, 38, 57, 1) 11.4%,
        rgba(63, 76, 119, 1) 70.2%
    );
    display: flex;
    align-items: center;
    justify-content: space-between;
    &.main {
        /* grid-area: main; */

        background: linear-gradient(
            171.8deg,
            rgba(5, 111, 146, 1) 13.5%,
            rgba(6, 57, 84, 1) 78.6%
        );
    }
    &.first {
        /* grid-area: first; */
        background: linear-gradient(25deg, #d64c7f, #ee4758 50%);
    }
    &.secound {
        /* grid-area: secound; */
        background-image: radial-gradient(
            circle farthest-corner at 10% 20%,
            rgba(255, 209, 67, 1) 0%,
            rgba(255, 145, 83, 1) 90%
        );
    }
    &.third {
        /* grid-area: third; */
        background-image: radial-gradient(
            circle farthest-corner at 10% 20%,
            rgba(14, 174, 87, 1) 0%,
            rgba(12, 116, 117, 1) 90%
        );
    }
    &.forth {
        /* grid-area: forth; */
    }
    .icons {
        svg {
            border-radius: 50%;
            background: rgba(0, 0, 0, 0.5);

            color: #fff;
            font-size: 4rem;
            width: 5rem;
            height: 5rem;
            padding: 0.8rem;
        }
    }
    .data {
        display: flex;
        flex-direction: column;
        z-index: 1;
        align-items: center;
        .key {
            color: #fefefe;
            font-size: 1rem;
            font-weight: 400;
            text-transform: uppercase;
            letter-spacing: 1px;
        }
        .value {
            font-size: 3.5rem;
            color: #fff;
            font-weight: 100;
            margin-top: -1rem;
        }
        .cost {
            font-size: 1.5rem;
            color: #fff;
            font-weight: bold;
            margin-top: -1rem;
        }
    }
    .iconback {
        position: absolute;
        top: 50%;
        right: 8%;
        transform: translate(-8%, -50%);
        svg {
            font-size: 7rem;
            color: rgba(0, 0, 0, 0.1);
            z-index: 0;
        }
    }
`;

export default AnalysisCard;
